const googleMapsHosts = new Set([
  "maps.app.goo.gl", "goo.gl", "www.google.com", "google.com", "maps.google.com",
  "www.google.ca", "maps.google.ca", "www.google.co.uk", "maps.google.co.uk",
  "www.google.com.au", "maps.google.com.au", "www.google.co.jp", "maps.google.co.jp",
  "www.google.co.in", "maps.google.co.in", "www.google.de", "maps.google.de",
  "www.google.fr", "maps.google.fr", "www.google.es", "maps.google.es",
  "www.google.it", "maps.google.it", "www.google.nl", "maps.google.nl",
]);

export type RestaurantInputKind = "empty" | "name" | "google-maps-url" | "url";

export function classifyRestaurantInput(value: string): RestaurantInputKind {
  const input = value.trim();
  if (!input) return "empty";

  let url: URL;
  try {
    url = new URL(input);
  } catch {
    return "name";
  }

  if (url.protocol === "https:" && googleMapsHosts.has(url.hostname.toLowerCase())) {
    return "google-maps-url";
  }
  return url.protocol === "http:" || url.protocol === "https:" ? "url" : "name";
}
